import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import useAlertStatus from './useAlertStatus';

export default function useShouldShowPriceDetails() {
  const { outOfMarket } = useAlertStatus();
  const { price = 0 } = useGetVehicleDetails();

  return !outOfMarket && price > 0;
}
